import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  evaluations: [],
  icons: {
    'kid': 'user',
    'young': 'user',
    'adult': 'user'
  }
}

// getters
export const getters = {
  evaluations: state => state.evaluations,
  kid: state => state.evaluations.find(e => e.title == 'kid'),
  young: state => state.evaluations.find(e => e.title == 'young'),
  adult: state => state.evaluations.find(e => e.title == 'adult')
}

// mutations
export const mutations = {
  [types.FETCH_EVALUATIONS_SUCCESS] (state, { evaluations }) {
    // Merge icons to evaluations.
    state.evaluations = evaluations.map(
      (e) => e = {...e, 'icon' : state.icons[e.title] }
    );
  },

  [types.FETCH_EVALUATIONS_FAILURE] (state) {
    // Fallback.
    state.evaluations = [
      { id: 1, name: 'kid', icon: state.icons['kid'], default_value: 5 },
      { id: 2, name: 'young', icon: state.icons['young'], default_value: 5 },
      { id: 3, name: 'adult', icon: state.icons['adult'], default_value: 5 }
    ];
  },
}

// actions
export const actions = {
  async fetchEvaluations ({ commit }) {
    try {
      const response = await axios.get(`/api/evaluations`)
      commit(types.FETCH_EVALUATIONS_SUCCESS, { evaluations: response.data })

      console.log(response.data)
    } catch (error) {
      console.error(error)
      commit(types.FETCH_EVALUATIONS_FAILURE)
    }
  },
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/evaluations.js